<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      :title="title"
      width="300px"
      :innerHeight="60"
      :qLoading="qLoading"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <el-form :model="formData" size="small" :rules="rules" ref="ruleForm">
        <el-form-item label="调整数量" prop="subMonthAdjust">
          <el-input v-model="formData.subMonthAdjust" :placeholder="placeholderVal" />
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
import { isIntZero } from '@/utils/validate.js'
import mixin from '@/views/preSalePlan/utils/mixin.js'
export default {
  mixins: [mixin],
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'data'],
  data() {
    const validator_IntZero = (rule, value, callback) => {
      if(isIntZero(value)) {
        callback()
      }else{
        callback(new Error('必须为正整数'))
      }
    }
    return {
      dialogVisible: false,
      // 业务代码
      formData: {
        subMonthAdjust: ''
      },
      title: '',
      placeholderVal: '',
      rules: {
        subMonthAdjust: [
          { required: true, message: '调整数量不能为空', trigger: 'blur'},
          { validator: validator_IntZero, trigger: 'change' }
        ]
      },
      qLoading: false
    }
  },
  created() {
    this.title = this.data.editKey === 'subMonthAdjust' ? '预估调整' : '大促预估调整'
    this.placeholderVal = this.data[this.data.editKey];
  },
  mounted() {
    this.dialogVisible = this.visible;
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.qLoading = true;
      this.$refs['ruleForm'].validate(valid=>{
        if(valid) {
          let data = {
            data: {
              goodsCode: this.data.goodsCode,
              planTime: this.planTime,
              storeId: this.storeId
            }
          }
          data.data[this.data.editKey] = this.formData.subMonthAdjust;
          this.$q.preSalePlan.goodSubModify(data)
          .then(res=>{
            res.code == 200 && this.$message.success('修改成功')
          })
          .finally(_=>{
            this.$parent.$parent.$parent.init();
            this.updateVal();
            this.qLoading = false;
          })
        }
      })
    }
  }
}
</script>

<style>

</style>